exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "#components-pagination-demo-mini .ant-pagination[data-v-2f2d07dd]:not(:last-child){margin-bottom:24px}", "", {"version":3,"sources":["/Users/chakritkanpromkad/Desktop/Sourcetree/Mariminterfood/pos_ui-Develop/src/views/adjust_item.vue"],"names":[],"mappings":"AACA,mFACE,kBAAoB,CACrB","file":"adjust_item.vue","sourcesContent":["\n#components-pagination-demo-mini .ant-pagination[data-v-2f2d07dd]:not(:last-child) {\n  margin-bottom: 24px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2f2d07dd","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/adjust_item.vue
// module id = 1394
// module chunks = 8